// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PharmacyCardFinderPatientResponse {
    static getAttributeTypeMap() {
        return PharmacyCardFinderPatientResponse.attributeTypeMap;
    }
}
PharmacyCardFinderPatientResponse.discriminator = undefined;
PharmacyCardFinderPatientResponse.additionalProperties = false;
PharmacyCardFinderPatientResponse.attributeTypeMap = [
    {
        "name": "birthDate",
        "baseName": "birthDate",
        "type": "string"
    },
    {
        "name": "name",
        "baseName": "name",
        "type": "PharmacyCardFinderPersonName"
    },
    {
        "name": "zipCode",
        "baseName": "zipCode",
        "type": "string"
    },
];
//# sourceMappingURL=pharmacyCardFinderPatientResponse.js.map